import type { NamedResource } from "~/client/resources";

export const toSelectItem = <T extends NamedResource>(item: T) => ({ value: item.Id, text: item.Name });

export default toSelectItem;
